import { bindActionCreators } from '@reduxjs/toolkit';
import { useAppDispatch, useAppSelector } from '@shared/model';
import {
  emailSenderStateActions,
  ISenderProgress,
  resetIsSendingEmail,
  setSendingErrors,
  updateProgress,
} from '@entities/sender-state';
import { useLazyGetSendingProgressQuery } from '@entities/generation-state';
import { setSendingIsTimedOut } from '@pages/invoice-generator/shared/model';
import toast from 'react-hot-toast';
import { usePolling } from '@modules/invoice-generator/invoice-generator-menu/hooks/usePolling';

const SendingPolling = () => {
  const stateId = useAppSelector(state => state.emailSenderState.sendingStateId);
  const [getSendingProgress] = useLazyGetSendingProgressQuery();

  const dispatch = useAppDispatch();
  const boundedActions = bindActionCreators(emailSenderStateActions, dispatch);

  usePolling<ISenderProgress>({
    queryKey: ['GET_SENDING_PROGRESS'],
    fetchData: () => getSendingProgress(stateId).unwrap(),
    onDataReceived: progress => {
      dispatch(updateProgress(progress));
      dispatch(setSendingErrors(progress.emailSendingErrors));
    },
    onComplete: (progress, status) => {
      boundedActions.setSendingErrors(progress.emailSendingErrors);
      boundedActions.resetSendingIsLoading();
      dispatch(resetIsSendingEmail());

      if (status === 'success') {
        toast.success('All emails were sent successfully');
      } else {
        toast.error('Failed to deliver all emails');
      }
    },
    onTimeout: progress => {
      boundedActions.resetSendingIsLoading();
      boundedActions.setSendingErrors(progress.emailSendingErrors);
      dispatch(setSendingIsTimedOut(true));
      dispatch(resetIsSendingEmail());

      toast.error('Timeout!', {
        duration: 3000,
      });
    },
  });

  return null;
};

export default SendingPolling;
